const SHOPPING_PAGES = {
  CATEGORIES: 'categories',
  BRANDS: 'brands',
  STORIES: 'stories',
  COLLECTIONS: 'collections',
  PRODUCTS: 'products',
};

// Returns the magento path for the supplied headless path.
export default function getMagentoPath(path) {
  const pathTokens = path.split('/').filter(Boolean);

  if (pathTokens.length <= 1) return null;

  const shoppingPage = pathTokens[0];

  switch (shoppingPage) {
    case SHOPPING_PAGES.CATEGORIES:
      return `${path.split(`/categories/`)[1]}.html`;
    case SHOPPING_PAGES.STORIES:
      return `stories/${path.split('/stories/')[1]}.html`;
    case SHOPPING_PAGES.PRODUCTS:
      return `${path.split('/products/')[1]}.html`;
    case SHOPPING_PAGES.COLLECTIONS:
    case SHOPPING_PAGES.BRANDS:
      return `${path}.html`;
    default:
      return '';
  }
}
